import { QSetProvider } from '@exam-management/common/qset-provider';
import {
  type PermissionRouteGuardData,
  PermissionRouteGuard,
} from '@exam-management/permission-route-guard';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { QSetDetailsHeader, QSetDetailsHeaderModalProvider } from '@exam-management/qset-details';
import { useParams } from '@exam-management/router';
import { Box, Flex } from '@shared/components';
import { Outlet } from 'react-router-dom';

export default function QSetDetailsLayout() {
  const { courseId, qSetId } = useParams('/exam-courses/:courseId/qsets/:qSetId');
  const defaultRoutes: PermissionRouteGuardData[] = [
    {
      path: '/exam-courses/:courseId/qsets/:qSetId',
      requiredPermission: [APP_PERMISSIONS.EXAM.QSET.VIEW, APP_PERMISSIONS.EXAM.AUDIT_LOG.VIEW],
      params: {
        courseId,
        qSetId,
      },
    },
    {
      path: '/exam-courses/:courseId/qsets/:qSetId/details',
      requiredPermission: [APP_PERMISSIONS.EXAM.QSET.VIEW],
      params: {
        courseId,
        qSetId,
      },
    },
    {
      path: '/exam-courses/:courseId/qsets/:qSetId/exam-details',
      requiredPermission: [APP_PERMISSIONS.EXAM.QSET.VIEW],
      params: {
        courseId,
        qSetId,
      },
    },
    {
      path: '/exam-courses/:courseId/qsets/:qSetId/review-history',
      requiredPermission: [APP_PERMISSIONS.EXAM.QSET.VIEW],
      params: {
        courseId,
        qSetId,
      },
    },
    {
      path: '/exam-courses/:courseId/qsets/:qSetId/activity-log',
      requiredPermission: [APP_PERMISSIONS.EXAM.AUDIT_LOG.VIEW],
      params: {
        courseId,
        qSetId,
      },
    },
  ];

  return (
    <PermissionRouteGuard routes={defaultRoutes}>
      <QSetProvider qSetId={qSetId}>
        <QSetDetailsHeaderModalProvider>
          <Flex sx={{ flexDirection: 'column', height: '100%' }}>
            <QSetDetailsHeader />
            <Box sx={{ flex: 1 }}>
              <Outlet />
            </Box>
          </Flex>
        </QSetDetailsHeaderModalProvider>
      </QSetProvider>
    </PermissionRouteGuard>
  );
}
